export const getFileNameWithExtension = (fileName) => {
  if (!fileName) return 'sample';

  if (fileName.endsWith('.pdf') || fileName.endsWith('.doc') || fileName.endsWith('.zip')) {
    return fileName;
  } else {
    return `${fileName}.pdf`;
  }
};
